/**
 * "Existing Road width approaching to plot" (cp_form_fields id 102) is a
 * dropdown of four road widths; the backend stores the chosen option's text
 * (civic-plan-backend/api/config/roadWidthOptions.js uses the same ids).
 *
 * Older applications hold a value from before the dropdown: "Yes" / "No"
 * (the first dropdown, options 180 / 181, now switched off) or a width typed
 * into the text box that came after it ("50", "6.096", "20 FOOT"). Such a
 * value is an "old value": it is kept as stored and shown to the reviewer,
 * who can choose one of the four widths or return the field to the
 * applicant, and the applicant must choose one of the four when the field is
 * returned to them.
 */
export const ROAD_WIDTH_FIELD_UID = "road_leading_to_land";

/** The four options, by their fixed cp_field_options ids. */
export const ROAD_WIDTH_OPTION_NAMES: Record<string, string> = {
  "9980": "6 m",
  "9981": "7.5 m",
  "9982": "9 m",
  "9983": "> 9 m",
};

/** The switched-off Yes / No options of the first dropdown. */
const LEGACY_ROAD_OPTION_NAMES: Record<string, string> = {
  "180": "Yes",
  "181": "No",
};

/**
 * The stored road width as a person reads it ("No" rather than "181"), or ""
 * when there is none.
 */
export function roadWidthText(value: unknown): string {
  const text = String(value ?? "").trim();
  return ROAD_WIDTH_OPTION_NAMES[text] || LEGACY_ROAD_OPTION_NAMES[text] || text;
}

/** True when the application holds a road width that is not one of the four options. */
export function isOldRoadWidth(value: unknown): boolean {
  const text = roadWidthText(value);
  if (!text) return false;
  return !Object.values(ROAD_WIDTH_OPTION_NAMES).some(
    (name) => name.toLowerCase() === text.toLowerCase()
  );
}
